import React, { useState } from "react";
import { Link } from "react-router-dom";

//
import { Modal, Form, Button, Spinner } from "react-bootstrap";

//
import { Formik } from "formik";
import * as yup from "yup";
import { contactUs } from "../../redux/features/user/actions";

const schema = yup.object().shape({
  email: yup.string().email().required(),
  message: yup.string().required(),
});

function NoUserAlarm() {
  const [show, setShow] = useState(false);

  const [loading, setLoading] = useState(false);

  const sendContactUs = async (e) => {
    // start loading
    setLoading(true);

    // set variable
    let content = { ...e, subject: "Register Request" };

    // request
    await contactUs(content).then((res) => {
      if (res) {
        setShow(false);
      }
    });

    // stop loading
    setLoading(false);
  };
  return (
    <>
      <div className="subscription-alarm">
        To register an account
        <a onClick={() => setShow(true)}>Contact us</a>
      </div>

      <Modal centered size="lg" show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <h5>Contact Form</h5>
        </Modal.Header>

        <Modal.Body>
          <p className="mb-4">
            Fill out the form below to complete the registration process. We
            will contact you via email
          </p>

          <Formik
            validationSchema={schema}
            onSubmit={sendContactUs}
            initialValues={{
              email: "",
              message: "",
            }}
          >
            {({ handleSubmit, handleChange, touched, errors }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <Form.Group
                  className="form-group"
                  controlId="validationFormik01"
                >
                  <Form.Label>Your email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    className="form-control"
                    onChange={handleChange}
                    autoComplete="off"
                    isInvalid={touched.email && !!errors.email}
                    isValid={touched.email && !errors.email}
                  />
                </Form.Group>

                <Form.Group
                  className="form-group"
                  controlId="validationFormik02"
                >
                  <Form.Label>Message</Form.Label>

                  <Form.Control
                    as="textarea"
                    rows={7}
                    name="message"
                    placeholder="Enter your message"
                    className="no-resize"
                    onChange={handleChange}
                    autoComplete="off"
                    isInvalid={touched.message && !!errors.message}
                    isValid={touched.message && !errors.message}
                  />
                </Form.Group>

                <div className="actions justify-content-between">
                  <div className="back">
                    Already have an account?{" "}
                    <Link to="/auth/login" className="text-info fw-bolder">
                      login here
                    </Link>
                  </div>

                  <Button size="lg" type="submit" variant="info">
                    Send
                    {loading && (
                      <div className="spinner-holder">
                        <Spinner animation="border" variant="white" size="sm" />
                      </div>
                    )}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default NoUserAlarm;
